import { apiResultHasErrors } from 'api/function/apiResultHasErrors'

export const apiResultWithoutErrors = (result: unknown) =>
  !apiResultHasErrors(result)
